module.exports = __webpack_public_path__ + "static/media/1.d9f75abd.png";